import { render, staticRenderFns } from "./DocumentoVehiculo.vue?vue&type=template&id=c1aa20aa"
import script from "./DocumentoVehiculo.vue?vue&type=script&lang=js"
export * from "./DocumentoVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports